import React, { Component } from 'react';
import Link from 'gatsby-link';
import styled from 'styled-components';
import Navigation from '../../componenten/Navigation';
import {
  InspirationWrapper,
  ProjectsImage,
  ProjectsWrapperWider,
  ProjectsTitle
} from '../../static/styles/styles';

const Sticky = styled.div`
  position: sticky;
  background-color: #fff;
  top: 160px;
  z-index: 3;
`;

class InspiratiePage extends Component {
  render() {
    const navItems = this.props.data.allNavigationJson.edges;
    const inspiratieItems = this.props.data.allInspiratieJson.edges[0].node;
    const subNavItems = navItems.filter(
      ({ node: navItem }, index) => index === 2
    );
    return (
      <div>
        <Sticky>
          <Navigation items={subNavItems} navType="sub" />
        </Sticky>
        <InspirationWrapper>
          {inspiratieItems.inspiratie.map((inspiratie, index) => {
            return (
              <ProjectsWrapperWider key={index}>
                <ProjectsImage src={inspiratie.img} alt="" />
              </ProjectsWrapperWider>
            );
          })}
        </InspirationWrapper>
      </div>
    );
  }
}

export const query = graphql`
  query InspiratiePageQuery {
    allNavigationJson {
      edges {
        node {
          to
          name
          key
          sub
          subItems {
            to
            name
            key
          }
        }
      }
    }
    allInspiratieJson {
      edges {
        node {
          inspiratie {
            img
          }
        }
      }
    }
  }
`;

export default InspiratiePage;



// WEBPACK FOOTER //
// ./src/pages/nieuws/inspiratie.js